module.exports = __webpack_public_path__ + "media/components/app-store/static/s2-510528cc24339826b9dfd1147b3b4884.jpg";